import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { RowInput } from "src/components/forms/RowInput";
import { Label } from "src/@/components/ui/label";

export default function ModalPrioridadeChamado({
  open,
  onClose,
  onSubmit,
  action,
  titulo,
  changeTitulo,
  cor,
  changeCor,
  tempoAceite,
  changeTempoAceite,
  tempoConclusao,
  changeTempoConclusao,
}) {
  const { t } = useTranslation('settings');

  const CORES_PREDEFINIDAS = [
    { valor: '#ef4444', nome: t('ticketSettings.colors.red', 'Vermelho') },
    { valor: '#f59e0b', nome: t('ticketSettings.colors.yellow', 'Amarelo') },
    { valor: '#22c55e', nome: t('ticketSettings.colors.green', 'Verde') },
    { valor: '#3b82f6', nome: t('ticketSettings.colors.blue', 'Azul') },
    { valor: '#8b5cf6', nome: t('ticketSettings.colors.violet', 'Violeta') },
    { valor: '#ec4899', nome: t('ticketSettings.colors.pink', 'Rosa') },
    { valor: '#f97316', nome: t('ticketSettings.colors.orange', 'Laranja') },
    { valor: '#06b6d4', nome: t('ticketSettings.colors.cyan', 'Ciano') },
    { valor: '#6b7280', nome: t('ticketSettings.colors.gray', 'Cinza') },
    { valor: '#7C3AED', nome: t('ticketSettings.colors.purple', 'Roxo') },
    { valor: '#dc2626', nome: t('ticketSettings.colors.darkRed', 'Vermelho Escuro') },
  ];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>
            {action === "Criar" ? t('ticketSettings.priority.modal.createTitle', 'Nova Prioridade') : t('ticketSettings.priority.modal.editTitle', 'Editar Prioridade')}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RowInput
            label={t('labels.title', { ns: 'common', defaultValue: 'Título' })}
            input={
              <Input
                onChange={changeTitulo}
                value={titulo}
                placeholder={t('ticketSettings.priority.modal.titlePlaceholder', 'Ex: Crítica')}
              />
            }
          />
          <div>
            <Label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
              {t('ticketSettings.common.colorLabel', 'Cor')}
            </Label>
            <div className="flex flex-wrap gap-2">
              {CORES_PREDEFINIDAS.map((c) => (
                <button
                  key={c.valor}
                  type="button"
                  onClick={() => changeCor(c.valor)}
                  className={`w-8 h-8 rounded-full border-2 transition-all ${
                    cor === c.valor
                      ? 'border-gray-900 scale-110 shadow-md'
                      : 'border-transparent hover:border-gray-300'
                  }`}
                  style={{ backgroundColor: c.valor }}
                  title={c.nome}
                />
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <RowInput
              label={t('ticketSettings.priority.modal.acceptTimeLabel', 'Tempo de Aceite (min)')}
              input={
                <Input
                  type="number"
                  onChange={changeTempoAceite}
                  value={tempoAceite}
                  placeholder={t('ticketSettings.priority.modal.acceptTimePlaceholder', 'Ex: 30')}
                  min={0}
                />
              }
            />
            <RowInput
              label={t('ticketSettings.priority.modal.completionTimeLabel', 'Tempo de Conclusão (min)')}
              input={
                <Input
                  type="number"
                  onChange={changeTempoConclusao}
                  value={tempoConclusao}
                  placeholder={t('ticketSettings.priority.modal.completionTimePlaceholder', 'Ex: 120')}
                  min={0}
                />
              }
            />
          </div>

          {/* Preview */}
          <div className="pt-2">
            <Label className="text-sm text-gray-600 mb-2 block">{t('ticketSettings.common.previewLabel', 'Preview')}</Label>
            <div className="flex items-center gap-2 p-3 border border-gray-200 rounded-md bg-gray-50">
              <span
                className="w-2.5 h-2.5 rounded-full"
                style={{ backgroundColor: cor }}
              />
              <span className="text-sm font-medium text-gray-900">
                {titulo || t('ticketSettings.priority.modal.previewFallback', 'Nome da prioridade')}
              </span>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onSubmit}>
            {action === "Criar" ? t('buttons.create', { ns: 'common', defaultValue: 'Criar' }) : t('buttons.save', { ns: 'common', defaultValue: 'Salvar' })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
